export default () => ({
  datadumps: [],
});
